
    <div class="item p-4 my-auto">
      <h3 class=" mb-2 text-2xl font-bold text-white" style="font-size: 20px !important;">
        Información enviada
      </h3>
      <p class="pb-4 text-sm text-pretty text-white fw-semibold" style="font-size: 16px !important;">
        En tu correo recibirás la información para ingresar a tu
        cuenta.
      </p>
      <div class="w-100 pb-3">
        <button-look-feel [block]="true" color="secondary" routerLink="/" customClass="py-2">Iniciar
          sesión</button-look-feel>
      </div>
      <div class="olvide-pas d-flex justify-content-center mt-2">
        <app-hyperlink-icon (clicked)="goToRecuperar()">¿No recibiste el correo con la información?</app-hyperlink-icon>
      </div>
      <div class="d-flex justify-content-center mt-2">
        <app-hyperlink-icon icon="arrow-left" (clicked)="goToHome()">Volver</app-hyperlink-icon>
      </div>
    </div>